import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { siteInfo } from "@/mocks/archive";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/timeline", label: "暗黑时间轴" },
  { to: "/archive", label: "档案库" },
  { to: "/about", label: "关于我们" },
];

export default function SiteNavbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/92 backdrop-blur-md border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="h-16 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3 cursor-pointer group">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-950">
              <i className="ri-node-tree text-2xl" aria-hidden="true"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
                {siteInfo.name}
              </span>
              <span className="mt-1 text-[10px] tracking-[0.28em] uppercase text-foreground-400">
                Dark Line Archive
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors ${
                    isActive
                      ? "text-primary-400 bg-primary-950/60"
                      : "text-foreground-600 hover:text-foreground-950 hover:bg-background-100"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#subscribe"
              className="px-4 py-2 rounded-md text-sm whitespace-nowrap cursor-pointer bg-primary-500 text-background-950 hover:bg-primary-400 transition-colors"
            >
              订阅更新
            </a>
          </div>

          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer"
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-100 px-4 pb-5">
          <nav className="flex flex-col py-2" aria-label="移动端导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-sm cursor-pointer ${
                    isActive ? "text-primary-400 bg-primary-950/50" : "text-foreground-700"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
          <a
            href="#subscribe"
            onClick={() => setOpen(false)}
            className="mt-2 block text-center px-4 py-3 rounded-md text-sm whitespace-nowrap cursor-pointer bg-primary-500 text-background-950"
          >
            订阅更新
          </a>
        </div>
      )}
    </header>
  );
}